import routes from "@/router/routes-list";

export const regionalUserMenus = routes
  .filter((route) => route.meta && route.meta.menu && !route.meta.menu.hidden)
  .map((route) => ({ key: route.path, label: route.meta.menu.label }));

export function getRegionalUserPermissions(user) {
  return user && user.regional_user && Array.isArray(user.regional_user.permissions)
    ? user.regional_user.permissions
    : null;
}

export function canAccessRegionalMenu(user, path) {
  const permissions = getRegionalUserPermissions(user);

  if (!permissions) {
    return true;
  }

  if (path === "/logout" || path === "/404" || path === "/atualizacad" || path === "/novidades") {
    return true;
  }

  // Regras e Regulamentos e Resumo dos rankings: liberados para quem tem algum ranking Nacional ou Estadual.
  if (path === "/biteams/rk-regulamento" || path === "/biteams/rk-resumo") {
    return permissions.some(
      (permission) => permission.indexOf("/biteams/rk-nacional-") === 0 || permission.indexOf("/biteams/rk-estadual-") === 0
    );
  }

  return permissions.some((permission) => {
    if (permission === "/") {
      return path === "/";
    }

    if (permission === "/notasfiscais/apvsbrasil" && path.indexOf("/nfs-brasil") === 0) {
      return true;
    }

    if (permission === "/notasfiscais/apvstruck" && path.indexOf("/nfs-truck") === 0) {
      return true;
    }

    if (permission === "/leads/leads" && path.indexOf("/lead/") === 0) {
      return true;
    }

    return path === permission || path.indexOf(permission + "/") === 0;
  });
}

export function firstRegionalUserPath(user) {
  const permissions = getRegionalUserPermissions(user);
  return permissions && permissions.length > 0 ? permissions[0] : "/404";
}
